var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external_view_FinishPaper"},[(_vm.loading)?_c('div',[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa","vertical":""}},[_vm._v("加载中...")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }